module.exports = __webpack_public_path__ + "assets/26fefa4044dd98ae5a1515cf70d8683a.png";